<template>
  <div class="app-container dida-worker-control">
    <el-card shadow="never" class="help-card">
      <div slot="header" class="clearfix">
        <span>Dida Worker 并发控制</span>
        <el-button style="float: right" type="primary" size="small" :loading="saving" @click="save">保存并生效</el-button>
      </div>
      <el-alert
        title="配置保存在共享数据库中，Go 服务会在下一轮调度前读取，无需重启。正在执行的任务不会被强制中断。"
        type="info"
        :closable="false"
        show-icon
      />
      <el-form ref="form" :model="form" :rules="rules" label-width="180px" class="worker-form">
        <el-form-item label="总并发上限" prop="total">
          <el-input-number v-model="form.total" :min="1" :max="512" :step="1" controls-position="right" />
          <span class="form-tip">没有供应商独立配置时用于自动分配。</span>
        </el-form-item>
        <el-form-item v-for="supplier in suppliers" :key="supplier.value" :label="supplier.label + '并发数'" :prop="'suppliers.' + supplier.value">
          <el-input-number v-model="form.suppliers[supplier.value]" :min="1" :max="256" :step="1" controls-position="right" />
          <span class="form-tip">当前调度周期最多同时处理的酒店数。</span>
        </el-form-item>
      </el-form>
      <el-divider />
      <div class="summary">
        <span>供应商并发合计：<b>{{ supplierTotal }}</b></span>
        <span>最近保存：{{ updatedAt || '-' }}</span>
      </div>
      <el-alert
        v-if="supplierTotal !== Number(form.total)"
        class="sum-warning"
        title="供应商独立配置优先于总并发；两者不相等时，总并发不会强行限制已配置的供应商。"
        type="warning"
        :closable="false"
      />
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      saving: false,
      updatedAt: '',
      suppliers: [
        { label: '锦江', value: 'jin_jiang' },
        { label: '隧穿亚朵', value: 'sui_chuan' },
        { label: '丽呈', value: 'li_cheng' },
        { label: '龙腾', value: 'long_teng' },
      ],
      form: {
        total: 128,
        suppliers: { jin_jiang: 20, sui_chuan: 4, li_cheng: 4, long_teng: 100 },
      },
      rules: {
        total: [{ required: true, message: '请输入总并发数', trigger: 'change' }],
      },
    }
  },
  computed: {
    supplierTotal() {
      return this.suppliers.reduce((sum, item) => sum + Number(this.form.suppliers[item.value] || 0), 0)
    },
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      request({ url: '/api/backend/dida/worker-controls', method: 'get' }).then(response => {
        const data = response.data || {}
        this.form.total = Number(data.total || this.form.total)
        ;(data.suppliers || []).forEach(item => {
          if (Object.prototype.hasOwnProperty.call(this.form.suppliers, item.scope)) {
            this.$set(this.form.suppliers, item.scope, Number(item.worker_count))
          }
        })
        this.updatedAt = data.updated_at || ''
      })
    },
    save() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        request({
          url: '/api/backend/dida/worker-controls/save',
          method: 'post',
          data: this.form,
        }).then(response => {
          const data = response.data || {}
          this.updatedAt = data.updated_at || new Date().toLocaleString()
          this.$message.success(response.msg || 'Worker并发配置已保存，下一轮调度生效')
        }).finally(() => {
          this.saving = false
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.help-card { max-width: 900px; }
.worker-form { margin-top: 24px; max-width: 760px; }
.form-tip { margin-left: 12px; color: #909399; font-size: 13px; }
.summary { display: flex; gap: 36px; color: #606266; }
.sum-warning { margin-top: 18px; max-width: 760px; }
</style>
